import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Menu14 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={14}
    contrast={contrast}
    className={className}
  >
    <path d='M12 3.75H2V2.25H12V3.75Z' fill='currentColor' />
    <path d='M12 7.75H2V6.25H12V7.75Z' fill='currentColor' />
    <path d='M2 11.75H12V10.25H2V11.75Z' fill='currentColor' />
  </Svg>
);

Menu14.displayName = 'Menu14';
export default Menu14;
